//global.URL_API_BASE_DOMAIN = "/proxy_api";
module.exports = {
  // URL_PROXY_API_BASE_DOMAIN: "https://iiot2.yizumi.com/api",
  URL_PROXY_API_BASE_DOMAIN: 'https://kunpeng.yizumi.com:82/api'
  //   URL_PROXY_API_BASE_DOMAIN: "https://iiot2testapi.yizumi.com:82/api",
  // URL_PROXY_API_BASE_DOMAIN: "http://127.0.0.1:8802",
};

global.URL_DEV_API_BASE_DOMAIN = 'http://172.18.120.188/api';
global.URL_DEV_PAGE_BASE_DOMAIN = 'http://172.18.120.188';
global.URL_DEV_WEBSOCKET = 'ws://172.18.120.188/ws';

global.URL_PRE_API_BASE_DOMAIN = 'https://iiot2test2.yizumi.com/api';
global.URL_PRE_PAGE_BASE_DOMAIN = 'https://iiot2test2.yizumi.com';
global.URL_PRE_WEBSOCKET = 'ws://iiot2test.yizumi.com/ws';

global.URL_PROD_API_BASE_DOMAIN = '/api';
global.URL_PROD_PAGE_BASE_DOMAIN = '';
global.URL_PROD_WEBSOCKET = '/ws';

global.URL_WEBSOCKET = process.env.NODE_ENV === 'development' ? global.URL_DEV_WEBSOCKET : process.env.VUE_APP_SERVER === 'preview' ? global.URL_PRE_WEBSOCKET : global.URL_PROD_WEBSOCKET;
